<template>

  <div class="product-list">
    <CCard>
      <CCardHeader>
        <strong>
          گزارش موجودی کالا ها
        </strong>

      </CCardHeader>

      <CCardBody class="">


        <CDataTableFixed
            class="mb-0 table-outline"
            hover
            striped
            sorter
            column-filter
            :pagination="true"
            :items-per-page="100"
            :items="items"
            :fields="fields"
            head-color="light"
        >
          <template #row_id="{item,index}">
            <td>
              <p>{{ index+1 }}</p>
            </td>
          </template>
          <template #created_at="{item}">
            <td>
              <p>{{ get_date_time(item.created_at) }}</p>
            </td>
          </template>
          <template #title="{item}">
            <td>
              <p>{{ item.title+" "+item.bundle_title }}</p>
            </td>
          </template>
          <template #operation="{item,index}">
            <td class="py-2">
              <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  @click="goOrderInfo(item)"
              >
                <CIcon name="eye" size="sm"/>
              </CButton>

            </td>
          </template>

        </CDataTableFixed>
      </CCardBody>
    </CCard>


  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";
import {CChartLineSimple} from "@/views/charts";


export default {
  name: 'Login',
  components: {
    CChartLineSimple
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {

      fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'کالا'},
        {key: 'product_count', label: 'تعداد', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      items: [],

    }
  },
  mounted() {

    this.get_data();

  },
  watch: {},
  methods: {
    goOrderInfo(item) {
      this.$router.push({path: '/dashboard/reports/products/' + item.price_id});
    },
    get_data() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/report/stock_report', form_data, {}).then(function (response) {
let data = []
        response.data.forEach(function (val){
          if(data.filter(x=>x.price_id == val.price_id).length>0){
            data.filter(x=>x.price_id == val.price_id)[0].bundle_title += " "+val.bundle_title
          }else{
            data.push(val)
          }
        })
        self.items = data;

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>
